import * as React from 'react';
import {FC} from 'react';
import {LegacyModal, Loader} from '@flexe/ui-components';
import ErrorDisplay from '../../shared/ErrorDisplay';
import FlexeButton from '../../shared/FlexeButton';
import {renderLpnLink} from '../../../libs/helpers';
import OutboundManifestService from '../../shared/services/OutboundManifestService';
import {ManifestLpn} from './ManifestInterfaces';

interface Props {
  toggleModal: () => void;
  show: boolean;
  authenticityToken: string;
  lpn: ManifestLpn;
  manifestId: number;
}

export const ManifestLpnConfirmRemoveModal: FC<Props> = (props) => {
  // Don't create content when not showing. This FC will be redrawn when the prop changes so
  // it will correctly display the given lpn's data.
  if (!props.lpn || !props.show) {
    return null;
  }

  const [errorText, setErrorText] = React.useState<string>();
  const [removing, setRemoving] = React.useState<boolean>(false); // The remove RPC

  const outboundManifestService = new OutboundManifestService(props.authenticityToken);

  const onConfirmHandler = async () => {
    if (removing) {
      return;
    }
    try {
      setRemoving(true);
      const response = await outboundManifestService.removeLpn(props.manifestId, props.lpn.lpn_barcode);

      if (response.errors && response.errors.length > 0) {
        setErrorText('An error occurred! The LPN was NOT removed from the manifest.');
      } else {
        props.toggleModal();
      }
    } catch (e) {
      setErrorText('An error occurred! The LPN may not have been removed from the manifest.');
    } finally {
      setRemoving(false);
    }
  };

  return (
    <LegacyModal
      id="manifest-lpn-remove-confirmation"
      transitionSpeed="fast"
      toggleModal={props.toggleModal}
      show={props.show}
      title={'Removing LPN'}
    >
      <div>
        <ErrorDisplay errorText={errorText} />
        <div className="msg-body">
          You are about to remove LPN {renderLpnLink(props.lpn.lpn_barcode, false)} from this load.
        </div>
        {/* <div className="loading-container">
          <Loader loading={removing} />
        </div> */}
        <div className="remove-btn-container">
          <FlexeButton
            level="collapsed-link"
            handleClick={props.toggleModal}
            title="Keep the LPN on this load"
            text="Go Back"
          />

          <span className="button-spacing" />

          <FlexeButton
            level="danger"
            handleClick={onConfirmHandler}
            isDisabled={removing || !!errorText}
            title="Remove the LPN from this load"
            text="Remove LPN"
          />
        </div>
      </div>
    </LegacyModal>
  );
};
